import { Button, Icon } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { AssetDefaultOrSelectedTypeMap } from '../../../../../../store/product/types';
import { DynamicProduct } from '../../../DynamicProduct';
import { availableProductFundsConstant } from '../../../DynamicProduct/components/Product/products/Funds/constants';
import { AvailableProductsType } from '../../../DynamicProduct/constants';

type P = AssetDefaultOrSelectedTypeMap[AvailableProductsType];

export const FundsContent: React.FC = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const [selectedOffers, setSelectedOffers] = useState<P[]>([]);

  const isSelected = (offer: P, idSelector: keyof P) => {
    return selectedOffers.some((o) => o[idSelector] === offer[idSelector]);
  };

  const handleSelectOffer = (offer: P, idSelector: keyof P) => {
    if (isSelected(offer, idSelector)) {
      setSelectedOffers((prev) => prev.filter((o) => o[idSelector] !== offer[idSelector]));
    } else {
      setSelectedOffers((prev) => [...prev, offer]);
    }
  };

  const handleCompareFunds = () => {
    navigation.navigate('FundsComparator', { selectedOffers });
  };

  return (
    <DynamicProduct
      infoGetter={(offer, idSelector) => ({
        handleSelect: () => handleSelectOffer(offer, idSelector as keyof P),
        isSelected: isSelected(offer, idSelector as keyof P),
      })}
      product={availableProductFundsConstant}
      customButton={
        <Button
          variant="secondary"
          rightIcon={<Icon name="Arrowswap" size="xs" />}
          onPress={handleCompareFunds}
          isDisabled={selectedOffers.length < 2}>
          Comparar
        </Button>
      }
    />
  );
};
